import { Pill } from "@src/appV2/redesign/system/ui-components";

export type Multiplier = number | string;

interface MultiplierPillProps {
  multiplier: Multiplier;
}

export function MultiplierPill({ multiplier }: MultiplierPillProps) {
  if (multiplier === "1" || multiplier === 1) {
    return null;
  }

  return (
    <Pill
      label={`${multiplier}x`}
      size="small"
      variant="outlined"
      backgroundColor={(theme) => theme.palette.background.tertiary}
    />
  );
}
